import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hoursToOptions' })
export class HoursToOptionsPipe implements PipeTransform {
  transform(hours: any[]): any[] {
    if (!hours || !Array.isArray(hours)) return [];
    return hours.map(h => ({ value: h, label: String(h) }));
  }
}